import { createSelector } from '@reduxjs/toolkit'
import { IBoardMember } from 'shared/models/Board'
import { getUser } from '../user/selectors'
import { SystemState } from './types'

export const getBoard = (state: SystemState) => state.board

export const getBoardMembers = (state: SystemState) => state.board.data?.members

export const getBoardFunctionForActiveUser = createSelector(
  [getUser, getBoard],
  (user, board) => {
    const nameId = user.data?.id

    const role = board.data?.members?.find(
      (x: IBoardMember) => x.person.id === nameId
    )
    return role?.memberFunction || ''
  }
)

export const getBoardSizeBasedOnMemberFunction = (state: SystemState) => {
  const membersWithQueriedFunctions = state.board.data?.members?.filter(
    (member) => member.boardMember || member.chairman || member.deputy
  )

  return membersWithQueriedFunctions?.length || 0
}
